export default "__VITE_ASSET__D_kwYt9U__"